(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-video-background"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.hero-video video').forEach((video) => {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;

      const maxBlur = 8;
      const maxScroll = 600;

      let blurValue = (scrollY / maxScroll) * maxBlur;
      blurValue = Math.min(blurValue, maxBlur);

      video.style.filter = `blur(${blurValue}px)`;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
